import { z } from "zod";

export const addHealthRecordSchema = z.object({
  physician: z.string({
    required_error: "Doctor Name or Lab Name is required",
  }),
});

export type AddHealthRecordSchema = z.infer<typeof addHealthRecordSchema>;
